export const MIME = {
  MARKDOWN: 'text/markdown',
  HTML: 'text/html',
  XML: 'text/xml',
  XHTML: 'application/xhtml+xml',
  XSLT: 'application/xslt+xml',
  HOCR: 'application/hocr+xml',
  PAGE: 'application/page+xml',
  ALTO: 'application/alto+xml',
  TEI: 'application/tei+xml',
  JS: 'text/javascript',
  CSS: 'text/css',
  JSON: 'application/json',
  JSONLD: 'application/ld+json',
}
